import { gsap } from "gsap";

const ParallaxImage = () => {
    const imgWrappers = document.querySelectorAll('[data-parallax-img-holder]');

    const initParallax = imgWrapper => {
        const img = imgWrapper.querySelector('img');
        const closestElement = imgWrapper.closest('.block');

        if (img && closestElement) {
            gsap.to(img, {
                yPercent: imgWrapper.dataset?.percent || Math.floor(Math.random() * 15),
                ease: "none",
                scrollTrigger: {
                    trigger: closestElement,
                    scrub: 1
                },
            });
        }
    }

    imgWrappers.forEach(initParallax);
}


export default ParallaxImage;
